import { gql } from '@apollo/client';

export const FLYERBOARD_OPTION_FRAGMENT = gql`
  fragment FlyerboardOption on FlyerboardFilterOption {
    value
    description
    amount
    disabled
  }
`;

export const GET_FLYERBOARD_FILTERS = gql`
  query getFlyerboardFilters($isSchool: Boolean!) {
    getFlyerboardFilters(isSchool: $isSchool) {
      grades_age {
        ...FlyerboardOption
      }
      types {
        ...FlyerboardOption
      }
      format {
        ...FlyerboardOption
      }
    }
  }
  ${FLYERBOARD_OPTION_FRAGMENT}
`;
